import { getAllCampaigns, getAllCreditNotes, getAllCustomers, getAllInvoices, getAllReturnOrders, getAllSalesOrders, getBillableOrders, getCampaignById, getCampaignReferenceData, getCustomerById, getCustomerReferenceData, getCustomersBySearch, getInvoiceById, getPrintInvoiceById, getReturnOrderById, getSalesOrderRowsById, getSalesOrdersById, getSalesOrdersBySearch } from "src/core/api/apiRequests";
import useResponse from "src/core/api/useResponse";
import { useGetAllPaginatedItems } from "src/core/api/useGetAllPaginatedItems";

export const useGetAllOrders = (shouldRequest: boolean | { current: boolean; } = true) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllSalesOrders,
        pageSize: 500,
        idField: "SalesOrderId",
        requestValues: null,
        shouldRequest,
    });
};

export const useGetSalesOrdersBySearch = (searchValue) => {
    const { rows: result } = useResponse<any[]>({
        requestFunction: getSalesOrdersBySearch,
        values: { searchValue },
        requestNothingOnNull: true,
        dependency: searchValue,
        extraCacheKey: String(searchValue),
    });
    console.log("useGetSalesOrdersBySearch", result);
    return result;
};

export const useLatestOrders = (amount = 5) => {
    const { rows: result } = useResponse<any[]>({
        requestFunction: getAllSalesOrders,
        values: { amount, pageSize: 1 },
        requestNothingOnNull: true,
    });
    return result;
};

export const useGetAllReturns = (shouldRequest = true) => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllReturnOrders,
        pageSize: 500,
        idField: "ReturnOrderId",
        requestValues: null,
        shouldRequest,
    });
};

export const useLatestReturns = (amount = 5) => {
    const { rows: result } = useResponse<any[]>({
        requestFunction: getAllReturnOrders,
        values: { amount, pageSize: 1 },
        requestNothingOnNull: true,
    });
    return result;
};

export const useOrderRowsById = (id: string) => {
    const { rows } = useResponse<any[]>({
        requestFunction: getSalesOrderRowsById,
        values: { id },
        requestNothingOnNull: true,
        dependency: id,
    });
    return rows;
};

export const useOrdersById = (id: string, dependency?: any) => {
    const { rows } = useResponse<any>({
        requestFunction: getSalesOrdersById,
        values: { id },
        requestNothingOnNull: true,
        dependency: [id, ...(Array.isArray(dependency) ? dependency : [dependency])],
    });
    return rows && String(rows.SalesOrderId) === String(id) ? rows : null;
};

export const useReturnsById = (id: string, dependecy?) => {
    const { rows: result } = useResponse<any>({
        requestFunction: getReturnOrderById,
        values: { id },
        requestNothingOnNull: true,
        dependency: [id, dependecy],
    });
    return result && String(result.ReturnOrderId) === String(id) ? result : null;
};

export const useGetAllCreditNotes = () => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllCreditNotes,
        pageSize: 1000,
        idField: "CreditNoteId",
    });
};

export const useGetAllInvoices = () => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllInvoices,
        pageSize: 1000,
        idField: "Id",
    });
};

export const useInvoiceById = (id: string) => {
    const response = useResponse<any[]>({
        requestFunction: getInvoiceById,
        values: { id },
        requestNothingOnNull: true,
        dependency: id,
    });
    return Array.isArray(response.rows) ? response.rows[0] ?? null : response.rows;
};

export const useGetAllCampaigns = () => {
    return useGetAllPaginatedItems<any>({
        requestFunction: getAllCampaigns,
        pageSize: 1000,
        idField: "Id",
    });
};

export const useCampaignId = (id: string) => {
    const { rows: result } = useResponse<any[]>({
        requestFunction: getCampaignById,
        values: { id },
        requestNothingOnNull: true,
        dependency: id,
    });
    return result;
};

export const useCampaignReferenceData = () => {
    const { rows } = useResponse<any[]>({
        requestFunction: getCampaignReferenceData,
    });
    return rows;
};

export const useGetAllCustomers = () => {
    const { rows, status } = useGetAllPaginatedItems<any>({
        requestFunction: getAllCustomers,
        pageSize: 1000,
        idField: "AccountId",
    });
    return { rows, status };
};

export const useGetCustomersBySearch = (searchValue) => {
    //const {rows: result} = useGetAllPaginatedItems<any[]>({requestFunction:getCustomersBySearch,idField:"AccountId",requestValues:{searchValue}, shouldRequest: searchValue != null});
    const { rows: result } = useResponse<any[]>({
        requestFunction: getCustomersBySearch,
        values: { searchValue },
        requestNothingOnNull: true,
        dependency: searchValue,
        extraCacheKey: String(searchValue),
    });
    //console.log("useGetCustomersBySearch", result, searchValue);
    return result;
};

export const useCustomerById = (id: string) => {
    const { rows: result } = useResponse<any[]>({
        requestFunction: getCustomerById,
        values: { id },
        requestNothingOnNull: true,
        dependency: id,
    });
    return result;
};

export const useCustomerReferenceData = () => {
    return useResponse<any>({
        requestFunction: getCustomerReferenceData,
    });
};

export const usePrintInvoiceById = (id: string, dependecy) => {
    const response = useResponse<any[]>({
        requestFunction: getPrintInvoiceById,
        values: { id },
        requestNothingOnNull: true,
        dependency: dependecy,
    });
    //   console.log("usePrintInvoiceById", response);
    return response?.rows ? response?.rows : null;
};

export const useBillableOrders = () => {
    return useResponse<any[]>({
        requestFunction: getBillableOrders,
    });
};
